import { useState } from "react";

interface NiceNameEditorProps {
  niceName: string | null;
  slug: string;
  onSave: (niceName: string | null) => void;
}

export function NiceNameEditor({
  niceName,
  slug,
  onSave,
}: NiceNameEditorProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedValue, setEditedValue] = useState(niceName ?? "");

  const handleClick = () => {
    setEditedValue(niceName ?? "");
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    const trimmed = editedValue.trim();
    const newValue = trimmed === "" ? null : trimmed;
    if (newValue !== niceName) {
      onSave(newValue);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.currentTarget.blur();
    } else if (e.key === "Escape") {
      setEditedValue(niceName ?? "");
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <input
        type="text"
        value={editedValue}
        onChange={e => setEditedValue(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        autoFocus
        placeholder={slug}
        className="border-b border-border bg-transparent px-0 py-0.5 text-sm outline-none"
      />
    );
  }

  return (
    <span
      onClick={handleClick}
      className="inline-flex cursor-pointer items-baseline gap-2 py-0.5 text-sm hover:text-muted-foreground"
    >
      {niceName ? (
        <>
          <span>{niceName}</span>
          <span className="font-mono text-xs text-muted-foreground">
            {slug}
          </span>
        </>
      ) : (
        <span className="font-mono">{slug}</span>
      )}
    </span>
  );
}
